<script setup lang="ts">
import { VIcon } from '@/modules/shared/components'

defineProps<{
  label: string
  value?: string
  layout?: 'row' | 'stack'
}>()

const emit = defineEmits<{
  (e: 'click'): void
}>()
</script>

<template>
  <button
    type="button"
    class="mb-[6px] w-full cursor-pointer rounded-md border-none bg-white px-4 py-[14px] text-left font-[inherit] shadow-sm ring-1 ring-gray-700/20 transition-shadow duration-150 ease-[cubic-bezier(0.22,1,0.36,1)] hover:shadow-md hover:ring-gray-700/30 active:translate-y-px active:shadow-sm"
    @click="emit('click')"
  >
    <div class="flex items-center gap-4">
      <span class="shrink-0 whitespace-nowrap text-xs font-semibold uppercase tracking-[0.5px] text-[#9ca3af]">{{
        label
      }}</span>
      <span
        v-if="layout !== 'stack'"
        class="flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-right text-[13px] font-medium text-[#374151]"
        >{{ value }}</span
      >
      <span v-else class="flex-1" />
      <VIcon name="ChevronRight" class="h-3.5 w-3.5 shrink-0 text-[#d1d5db]" />
    </div>
    <div v-if="layout === 'stack'" class="mt-2">
      <slot />
    </div>
  </button>
</template>
